export default __webpack_public_path__ + "static/media/shoot-away-icon.a9c19055.png";